module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"query_objects":"Query Objects","cutout":"Cutout","clear":"Clear"},"ja":{"query_objects":"天体を問い合わせる","cutout":"切り出し","clear":"クリア"}}')
  delete Component.options._Ctor
}
